export default __webpack_public_path__ + "static/media/021-kayak.02449d97.svg";